var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFassadeicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.272,
    height: 52.806,
    viewBox: "0 0 52.272 52.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fassade_icon",
    "data-name": "fassade icon",
    transform: "translate(0.5 0.5)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39842",
    "data-name": "Group 39842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39838",
    "data-name": "Group 39838",
    transform: "translate(0.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35759",
    "data-name": "Path 35759",
    d: "M47.3,59.429,74.169,43.821l12.3-4.321L59.6,55.133Z",
    transform: "translate(-47.3 -39.5)",
    fill: "#eceff1",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39839",
    "data-name": "Group 39839",
    transform: "translate(12.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35760",
    "data-name": "Path 35760",
    d: "M95.7,55.133,122.569,39.5l12.049,18.379L107.749,73.487Z",
    transform: "translate(-95.7 -39.5)",
    fill: "#eceff1",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39840",
    "data-name": "Group 39840",
    transform: "translate(0 15.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35761",
    "data-name": "Path 35761",
    d: "M59.454,101,71.5,119.353l-.051,17.819L47.1,123.115l.051-17.819Z",
    transform: "translate(-47.1 -101)",
    fill: "#34454e",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39841",
    "data-name": "Group 39841",
    transform: "translate(24.352 18.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35762",
    "data-name": "Path 35762",
    d: "M142.951,127.408,169.82,111.8l-.051,17.819L142.9,145.227Z",
    transform: "translate(-142.9 -111.8)",
    fill: "#34454e",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFassadeicon);
export default __webpack_public_path__ + "static/media/fassade icon.42e5b71eae7d7de24d1921a0ce6c6e44.svg";
export { ForwardRef as ReactComponent };